import React, { useState, useEffect } from 'react';
import { Button, Modal, Container, Grid, Paper } from '@mui/material';
import ListAltIcon from '@mui/icons-material/ListAlt';
import { DataGridPro } from '@mui/x-data-grid-pro';
import LinearProgress from '@mui/material/LinearProgress';
import CustomNoRowsOverlay from "../../components/CustomNoRowsOverlay";
import {AddCreditSearchBar} from './AddCreditBar';
import {AxiosSyncDefaultRequest} from "../../components/default_request";
import ToolBar from '../../components/ToolBar'
import server from "../../server";
import APICircularProgress from "../../components/APICircularProgress";

function AddCreditPage() {
    const [open, setOpen] = useState(false);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [pageSize, setPageSize] = useState(30);
    const [page, setPage] = useState(1);
    const [rowCount, setRowCount] = useState(0);
    const [sortModal, setSortModal] = useState({});
    const [api_loading, setApiLoading] = useState(null);
    const [searchData, setSearchData] = useState({
        start_create_time: null, end_create_time: null, username: "", remark: '', submitType: null,
    });
    const [columns, setColumns] = useState([
        {id: 0, field: "id", headerName: "Id"},
        {id: 1, field: "user", headerName: "User", width: 150, renderCell: (params) => {
            return params.value.username;
            }},
        {id: 2, field: "bill_msg", headerName: "Remark", width: 200},
        {id: 3, field: "create_time", headerName: "Create time", width: 200},
        {id: 4, field: "change_credit", headerName: "Change Credit", width: 200},
    ]);
    const [visibility, setVisibility] = useState({});
    const [search, setSearch] = useState('');
    useEffect(() => {
        if (open){
            fetchData(page, pageSize);
        }
    }, [open]);
    useEffect(() => {
        if (search){
            fetchData(page, pageSize, searchData, )
            setSearch(false);
        }
    }, [search])
    const fetchData = async (newPage=1, newPageSize=30, searchQuery=searchData, sortData=sortModal, submitType={submitType: "GET"}) => {
        try {
            const response = await AxiosSyncDefaultRequest({
                url: server.add_credit_url,
                params: {
                    curr_page: newPage,
                    page_size: newPageSize,
                    ...searchQuery,
                    ...sortData,
                    ...submitType,
                    create_time_after: searchQuery.start_create_time ? searchQuery.start_create_time.toLocaleDateString("en-US") : null,
                    create_time_before: searchQuery.end_create_time ? searchQuery.end_create_time.toLocaleDateString("en-US") : null
                }
            });
            if (submitType.submitType === "GET"){
                setData(response.data.rows);
                setRowCount(response.data.total);
                setLoading(false);
            }else {
                setApiLoading(null)
            }

        } catch (error) {
            console.error('Error fetching data:', error);
            // 可以在这里处理错误，例如设置错误消息
        }
    };
    const handleDateFieldChange = (fieldName) => (newValue) => {
        // 直接设置 Date 对象到状态中
        console.log({ ...searchData, [fieldName]: newValue });
        setSearchData({ ...searchData, [fieldName]: newValue });
    };
    // 页面改变处理
    const handlePageChange = (newPage) => {
        if (newPage === 0){
            newPage = 1;
        }
        if (page === 1 && newPage === 1){
            newPage = 2;
        }
        setLoading(true);
        setPage(newPage);
        setData([]);
        setRowCount(0);
        fetchData(newPage, pageSize);
    };

    // 页面大小改变处理
    const handlePageSizeChange = (newSize) => {
        setLoading(true);
        setPageSize(newSize);
        setData([]);
        setRowCount(0);
        fetchData(page, newSize);
    };

    // 搜索处理
    const handleSearch = (newSearch) => {
        setLoading(true);
        setData([]);
        setRowCount(0);
        setSearch(newSearch);
    };
    const handleExport = () => {
        setApiLoading(APICircularProgress("success"))
        fetchData(page, pageSize, searchData, sortModal, {submitType: "export"})
    }
    const Refresh = () => {
        setData([]);
        setLoading(true);
        fetchData(page, pageSize)
        setSearch(false);
    };
    const handleColumnOrderChange = (e) => {
        let newColumns = [...columns];
        const movedItem = newColumns.splice(e.oldIndex, 1)[0];
        newColumns.splice(e.targetIndex, 0, movedItem);
        setColumns(newColumns);
        // localStorage.setItem('yourLocalStorageKey', JSON.stringify(newColumns));
    };

    const handleColumnVisibilityChange = (newModel) => {
        // localStorage.setItem('yourLocalStorageVisibilityKey', JSON.stringify(newModel));
        setVisibility(newModel);
    };

    const handleSortModelChange = async (sortModel) => {
        let ordering = '';
        if (sortModel.length > 0) {
            // 处理所有的排序模型，虽然通常只有一个
            ordering = sortModel.map(model => {
                return model.sort === 'asc' ? model.field : `-${model.field}`;
            }).join(',');
        }
        // 构造排序的数据结构
        const sortData = { ordering };
        // 调用 fetchData 函数请求数据
        setLoading(true);
        setData([]);
        setSortModal(sortData);
        await fetchData(page, pageSize, search, sortData);
    };

    return (
        <span>
            {api_loading}
      <Button startIcon={<ListAltIcon/>} onClick={() => setOpen(true)}>充值记录</Button>
      <Modal open={open} onClose={() => setOpen(false)} aria-labelledby="add-credit-title" aria-describedby="add-credit-description">
        <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={8} lg={9}>
              <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column', height: 800 }}>
                <DataGridPro
                    rows={data}
                    sx={{ minHeight: 750, overflow: 'auto', display: 'block' }}
                    columns={columns}
                    pageSize={pageSize}
                    rowsPerPageOptions={[20, 30, 50, 100, 200, 500]}
                    autoHeight={true}
                    loading={loading}
                    rowCount={rowCount}
                    paginationMode='server'
                    columnVisibilityModel={visibility}
                    onColumnVisibilityModelChange={handleColumnVisibilityChange}
                    rowReordering={false}
                    onColumnOrderChange={handleColumnOrderChange}
                    onSortModelChange={handleSortModelChange}
                    components={{
                        LoadingOverlay: LinearProgress,
                        NoRowsOverlay: CustomNoRowsOverlay,
                        Toolbar: () => <ToolBar onRefresh={Refresh} />,
                    }}
                    onPageChange={handlePageChange}
                    onPageSizeChange={handlePageSizeChange}
                    pagination={true}
                />
              </Paper>
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column', height: 500 }}>
                <AddCreditSearchBar
                    searchData={searchData}
                    setSearchData={setSearchData}
                    search={search}
                    setSearch={handleSearch}
                    setCurrentPage={setPage}
                    handleExport={handleExport}
                />
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Modal>
    </span>
    );
}

export default AddCreditPage; // Assuming all props are passed correctly
